import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['helpicon', 'helpiconLink', 'datepickerInput'];

  connect() {
    // HACK : ONLY ON MOBILE
    // triggers connect on openning the datepicker analysis tool
    this.datepickerInputTarget.addEventListener('focus', (e) => {
      // the calendar opens on touchstart on the help icon, this hack prevents that
      e.stopImmediatePropagation();
    });

    // HACK : ONLY ON DESKTOP
    // triggers connect on openning the datepicker analysis popup
    if (this.hasHelpiconLinkTarget) {
      // the calendar opens on mousedown on the link inside the help icon, this hack prevents that
      this.helpiconLinkTarget.addEventListener('mousedown', (e) => {
        e.preventDefault();
      });
    };
  }
}
